/* Design-notes AI nudge — LEGACY by-size PDP injector (A/B parity with the
   v4 arm's feature, Owen 2026-07-15). The v4 twin lives in cart.js/modal.js;
   this page's engine (bySizeNew, 433KB) is unpushable, so the feature rides
   the proven standalone-injector pattern (dtf-finance-terms.js precedent).

   Behavior (mirrors v4): expanding an "Add Free design notes" card first
   shows an Edit-with-AI offer instead of the textarea. "No, I want to leave
   a note" -> textarea + focus, dismissed for that card. "Try edit with AI"
   -> collapses the card (through its own header toggle — the shared
   nt-design-note snippet's document handler owns data-collapsed) and opens
   the legacy Edit-with-AI modal, focusing its prompt.

   Wiring facts (nt-dtf-3col.js:752-755, :894-895): the engine's opener is a
   jQuery delegate on '.edit-with-ai .edit-with-aiFlex', so we must click the
   .edit-with-aiFlex CHILD — and exclude .nt-recolor-btn, which shares the
   class. Prompt = #ai_prompt_2. The nudge only offers itself when that
   affordance exists on the page (post-upload; feature-gated products never
   see it). Loaded ONLY on template suffix by-size-middle-scroll
   (theme.liquid gate) — v4 and UV templates excluded.

   Removal plan: when the A/B test ends, delete this file + its css + the
   theme.liquid include. No engine or shared-snippet changes to unwind. */
(function () {
  if (window.__ntNotesNudge) return;
  window.__ntNotesNudge = true;

  var WRAP_HTML =
    '<div class="ntn-nudge">' +
    '<p class="ntn-nudge__copy">Small change? <b>Edit with AI</b> fixes colors, text &amp; more instantly.</p>' +
    '<button type="button" class="ntn-nudge__try">' +
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 13.6 9.1 20.5 11 13.6 12.9 12 20 10.4 12.9 3.5 11 10.4 9.1 12 2Z"/><path d="M19 3 19.7 5.3 22 6 19.7 6.7 19 9 18.3 6.7 16 6 18.3 5.3 19 3Z" opacity=".75"/><path d="M5 14 5.6 15.7 7.3 16.3 5.6 16.9 5 18.6 4.4 16.9 2.7 16.3 4.4 15.7 5 14Z" opacity=".55"/></svg>' +
    'Try edit with AI <span aria-hidden="true">→</span></button>' +
    '</div>' +
    '<button type="button" class="ntn-nudge__no">No, I want to leave a note</button>';

  function aiEditTargetFor(note) {
    // THIS card's pill, not the document's first: a global query matched the
    // hidden single-flow .edit-with-ai under the multiupload view, so Try
    // opened the engine's ACTIVE (last) file (Owen 2026-07-15 repro). Walk up
    // from the note; the nearest ancestor containing a pill is the card
    // (multi — every uploaded-files-block carries its own, visually collapsed
    // behind the AI Edit Tools dropdown but still the engine's per-file
    // delegate target: clicking it opens THAT file, verified 2026-07-15) or
    // the shared tools rail (single). Deliberately NOT the .nt-aied-item —
    // a synthetic item click skips the menu-open that stamps its file scope,
    // and it falls back to document-wide (the original wrong-file path).
    var el = note;
    while (el && el !== document.body) {
      if (el.querySelector) {
        var btn = el.querySelector('.edit-with-ai:not(.nt-recolor-btn)');
        if (btn) return btn.querySelector('.edit-with-aiFlex') || btn;
      }
      el = el.parentElement;
    }
    return null;
  }

  function ensureWrap(note) {
    var wrap = note.querySelector('.ntn-nudge-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'ntn-nudge-wrap';
      wrap.innerHTML = WRAP_HTML;
      note.appendChild(wrap);
    }
    return wrap;
  }

  function focusPrompt(tries) {
    var p = document.getElementById('ai_prompt_2');
    if (p && p.offsetParent) return p.focus();
    if (tries > 0) setTimeout(function () { focusPrompt(tries - 1); }, 250);
  }

  document.addEventListener('click', function (e) {
    var no = e.target.closest && e.target.closest('.ntn-nudge__no');
    if (no) {
      var note = no.closest('.nt-design-note');
      note.dataset.ntnDismissed = '1'; // per-card = per-upload on this page
      note.classList.remove('ntn-nudging');
      var ta = note.querySelector('textarea');
      if (ta) ta.focus();
      return;
    }

    var tryBtn = e.target.closest && e.target.closest('.ntn-nudge__try');
    if (tryBtn) {
      var note2 = tryBtn.closest('.nt-design-note');
      note2.classList.remove('ntn-nudging');
      // collapse through the card's OWN header toggle (real flow — the shared
      // snippet's document handler flips data-collapsed + aria)
      if (note2.getAttribute('data-collapsed') === 'false') {
        var hdr = note2.querySelector('.nt-design-note__header');
        if (hdr) hdr.click();
      }
      var target = aiEditTargetFor(note2);
      if (target) {
        target.click();
        focusPrompt(8); // legacy modal shows async; poll ~2s
      }
      return;
    }

    var header = e.target.closest && e.target.closest('.nt-design-note__header');
    if (!header) return;
    var card = header.closest('.nt-design-note');
    // decide from the SETTLED state — the snippet's own document-level toggle
    // may run before or after us depending on bind order (v4 lesson: never
    // assume handler order)
    setTimeout(function () {
      var ta = card.querySelector('textarea');
      var open = card.getAttribute('data-collapsed') === 'false';
      var nudge =
        open &&
        !card.dataset.ntnDismissed &&
        !(ta && ta.value.trim()) &&
        !!aiEditTargetFor(card);
      if (nudge) ensureWrap(card);
      card.classList.toggle('ntn-nudging', nudge);
    }, 0);
  });
})();
